import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService, NgxSpinnerComponent } from  'ngx-spinner';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { LoginService } from '../login/login.service';

@Component({
  selector: 'app-changepassword',
  templateUrl: './changepassword.component.html',
  styleUrls: ['./changepassword.component.css']
})
export class ChangepasswordComponent implements OnInit {
  @ViewChild('changePasswordForm') changePasswordForm:NgForm;
  responseData: any;
  oldPassword: any = '';
  newPassword: any = '';
  constructor(private service : LoginService, private toastr : ToastrService, private spinner : NgxSpinnerService, private router : Router) { }

  ngOnInit(): void {
  }
  onSubmit() {
    if (this.changePasswordForm.valid) {

      if (this.changePasswordForm.value['oldPassword'] == this.changePasswordForm.value['newPassword']) {
        this.toastr.error("Old Password must be different to New Password");
        return;
      }

      if (this.changePasswordForm.value['confirmPassword'] != this.changePasswordForm.value['newPassword']) {
        this.toastr.error("Password and Confirm Password does not match");
        return;
      }
      
      this.spinner.show();

      const data = {
        oldPassword: this.changePasswordForm.value['oldPassword'],
        newPassword: this.changePasswordForm.value['newPassword']
      }

      this.service.changePassword(data)
      .subscribe(data => {
        this.responseData = data;

        this.spinner.hide();

        if (this.responseData.status == false)
        {
          this.toastr.error(this.responseData.message);
        }
        else
        {
          this.toastr.success(this.responseData.message);
          this.changePasswordForm.resetForm();
          this.router.navigate(["/login"]);
        }
      },
      (err: HttpErrorResponse) => {
        localStorage.clear();
        this.spinner.hide();
        this.toastr.error('Something Went Wrong');
        this.router.navigate(['/aciadmin']);
      });
    }
  }
}
